import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { sessionKey } from '@/entities/session';
import { ApiClientError, isApiError } from '@/shared/api';

/**
 * Server state lives here. A 401 anywhere means the BFF session ended: the session is
 * refetched and the router sends the user to the sign-in page.
 */
export function createQueryClient(): QueryClient {
  const client: QueryClient = new QueryClient({
    queryCache: new QueryCache({ onError: (error, query) => onError(error, query.queryKey) }),
    mutationCache: new MutationCache({ onError: (error) => onError(error, []) }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        retry: (count, error) => count < 2 && retryable(error),
      },
      mutations: { retry: false },
    },
  });

  function onError(error: unknown, key: readonly unknown[]) {
    if (isApiError(error, 'unauthenticated') && key[0] !== sessionKey[0]) {
      void client.invalidateQueries({ queryKey: sessionKey });
    }
  }
  return client;
}

function retryable(error: unknown): boolean {
  if (!(error instanceof ApiClientError)) return false;
  return error.code === 'network' || error.status >= 500;
}
